import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuthTemplate } from '@/components/auth/auth-template';
import { SelectBranchForm } from '@/features/auth/select-branch-form';
import { authStore } from '@/lib/auth-store';
import { safePortalReturn } from '@/lib/navigation';
import { effectiveReturn } from '@/lib/platform-lock';

function SelectBranchPage() {
  const { returnTo } = Route.useSearch();
  return (
    <AuthTemplate>
      <SelectBranchForm returnTo={effectiveReturn(returnTo)} />
    </AuthTemplate>
  );
}

export const Route = createFileRoute('/select-branch')({
  validateSearch: (search: Record<string, unknown>): { returnTo?: string } => ({
    returnTo: safePortalReturn(search['returnTo']),
  }),
  beforeLoad: async () => {
    if (!(await authStore.restore())) throw redirect({ to: '/login' });
  },
  component: SelectBranchPage,
});
